var render = function render(_c,_vm){return _c('div',{staticClass:"progress-bar-preview__wrapper"},[_c('div',{staticClass:"progress-bar-preview"},[_c('div',{staticClass:"progress-bar-preview__bar",class:_vm.props.size === 'small'
          ? 'progress-bar-preview__bar__small'
          : 'progress-bar-preview__bar__medium',style:(`width: ${_vm.props.value}%`)})]),(_vm.props.displayValue)?_c('div',{staticClass:"progress-bar-preview__value"},[_vm._v(" "+_vm._s(`${_vm.props.value}%`)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }